import { render, staticRenderFns } from "./QcngSetList.vue?vue&type=template&id=65b98008"
import script from "./QcngSetList.vue?vue&type=script&lang=js"
export * from "./QcngSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports